import { useCallback } from 'react';
import { useAuthContext } from '@unicus/react-ui-kit';
import { ROLE_ADMIN } from 'constants/types';

const useAuth = (getKey = null) => {
  const auth = useAuthContext(getKey);

  const hasRole = useCallback(
    (...roles) => auth.user.roles.some((role) => roles.includes(role)),
    [auth.refreshToken]
  );

  const hasAccountType = useCallback(
    (...types) =>
      auth.user.tenants.some((account) => types.includes(account.type)),
    [auth.refreshToken]
  );

  const hasFeature = useCallback(
    (...features) =>
      auth.features.some((feature) => features.includes(feature)),
    [auth.refreshToken]
  );

  const isAdmin = useCallback(
    () => auth?.user?.roles?.some((role) => role === ROLE_ADMIN) ?? false,
    [auth.refreshToken]
  );

  return {
    ...auth,
    authenticating: auth?.authenticating ?? false,
    serviceProvider: auth?.user?.serviceProvider,
    company: auth?.company,
    hasRole,
    hasFeature,
    hasAccountType,
    isAdmin
  };
};

export default useAuth;
